import styled from "@emotion/styled";
import Button from "@mui/material/Button";
import useTranslation from "next-translate/useTranslation";

import ContentPlaceholder from "~/components/common/ContentPlaceholder";

interface ErrorPlaceholderProps {
  onClickTryAgain?: () => void;
  className?: string;
}

const ErrorPlaceholder = ({
  onClickTryAgain,
  className
}: ErrorPlaceholderProps): JSX.Element => {
  const { t } = useTranslation("common");

  return (
    <StyledContentPlaceholder
      className={className}
      imageVariant="unknownError"
      caption={t("unknown-error-placeholder_title")}
      text={t("unknown-error-placeholder_description")}
    >
      {onClickTryAgain && (
        <StyledButton color="brandGreen" onClick={onClickTryAgain} size="large">
          {t("unknown-error-placeholder_try-again")}
        </StyledButton>
      )}
    </StyledContentPlaceholder>
  );
};

export default ErrorPlaceholder;

const StyledContentPlaceholder = styled(ContentPlaceholder)`
  border: 1px solid ${({ theme }) => theme.palette.background.senary};
  border-radius: 24px;
  max-width: 752px;
  padding: ${({ theme }) => theme.spacing(18, 4)};
`;

const StyledButton = styled(Button)`
  margin-top: ${({ theme }) => theme.spacing(4)};
  max-width: 344px;
  width: 100%;
`;
